import { render, staticRenderFns } from "./ModalCentral.vue?vue&type=template&id=b9c00bf2&scoped=true&"
import script from "./ModalCentral.vue?vue&type=script&lang=js&"
export * from "./ModalCentral.vue?vue&type=script&lang=js&"
import style0 from "./ModalCentral.vue?vue&type=style&index=0&id=b9c00bf2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9c00bf2",
  null
  
)

export default component.exports